import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import { getBestSellingProducts } from "../services/apiCalls";
import { useNavigate } from "react-router-dom";

const BestsellerList = () => {
    const [hoveredProductId, setHoveredProductId] = useState(null);
    const [products, setproducts] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchGetProducts = async () => {
            try {
                const response = await getBestSellingProducts();
                setproducts(response.data);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        fetchGetProducts();
    }, []);

    const handleCardClick = (productId) => {
        navigate(`/product/${productId}`);
    };

    return (
        <Box
            sx={{
                maxWidth: "100%",
                overflow: "hidden",
                padding: "20px",
                backgroundColor: "#f5f5f5",
                borderRadius: 0,
            }}
        >
            <Typography
                // fontSize={"20px"}
                fontWeight={"600"}
                color={"#1e1e1e"}
                textAlign="left"
                sx={{ marginBottom: "16px" }}
                fontSize="1.2rem"
                fontFamily="'Playfair Display', serif"
            >
                Best Seller
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                }}
            >
                {products.map((product) => (
                    <Box
                        key={product.id}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "16px",
                            padding: "16px",
                            borderRadius: 0,
                            backgroundColor: "transparent",
                            // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            ":hover": {
                                // boxShadow: "0 6px 18px rgba(0, 0, 0, 0.2)",
                            },
                        }}
                        onClick={() => handleCardClick(product.id)}
                        onMouseEnter={() => setHoveredProductId(product.id)}
                        onMouseLeave={() => setHoveredProductId(null)}
                    >
                        <Box
                            component="img"
                            // src={hoveredProductId === product.id ? product.images : product.image}
                            src={product.image}
                            alt={product.description}
                            sx={{
                                width: "100px",
                                height: "100px",
                                borderRadius: 0,
                                objectFit: "cover",
                                transition: "opacity 0.5s ease",
                            }}
                        />
                        <Box
                            sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography
                                variant="caption"
                                fontSize={"12px"}
                                color={"#bebebe"}
                                sx={{ marginBottom: "4px" }}
                            >
                                {product.category_name}
                            </Typography>
                            <Typography
                                variant="body1"
                                fontWeight="bold"
                                fontFamily={"'Playfair Display', serif"}
                                sx={{
                                    marginBottom: "8px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                }}
                            >
                                {product.name}
                            </Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    // fontWeight="400"
                                    fontFamily="'Nunito Sans', sans-serif"
                                    textAlign={"center"}
                                    fontSize={"16px"}
                                >
                                    {product.currency}
                                    {product.price}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default BestsellerList;
